import { updateVideoSession, VideoSessionName } from 'state-machines/new-video-session-state';

export type LivePlayerState = {
  currentMediaId: string;
  primarySession: boolean;
};

export const DEFAULT_LIVE_PLAYER_STATE: LivePlayerState = {
  currentMediaId: '',
  primarySession: true,
};

export const useUpdateLiveMediaId = (mediaId: string, sessionName?: VideoSessionName): void => {
  updateVideoSession({ livePlayerState: { currentMediaId: mediaId } }, true, sessionName);
};

export type ContinuousPlay = {
  bracketID: number;
  startTimeEpoch: number | void;
};
